module.exports = __webpack_public_path__ + "static/media/activeCustomers.f79df9c1.svg";